import React, { FC } from 'react';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import { TStepType } from '../../types/formPageNavigation.types';

const Step: FC<TStepType> = (props: TStepType) => {
    const {activeStepkey, formSubmitted, stepKey, stepRef, stepNumber, stepText, activeStepNumber, updateActiveStepNumber} = props;
    const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

    let className = '';

    if (activeStepkey === stepKey) {
        className = 'form-page-navigation__step--active';
        updateActiveStepNumber(stepNumber);
    }

    if ((stepNumber < activeStepNumber) || formSubmitted) {
        className = 'form-page-navigation__step--passed';
    }

    const addRef = (el) => {
        if (stepRef && stepRef?.current) {
            stepRef.current[stepNumber - 1] = el;
        }
    }
    return (
        <li key={stepKey} id={stepKey} className={`form-page-navigation__step ${className}`} ref={addRef}>
            <span className={'form-page-navigation__step__circle'} />
            {isDesktop && <span className={'form-page-navigation__step__title'}><DictionaryTerm keyword={'cnhi-form-step'} /> {stepNumber}</span>}
            {isDesktop && <span className={'form-page-navigation__step__name'}>{stepText}</span>}
        </li>
    );
}

export default Step;
